<template>
  <div>
    <zj-layout-container   v-loading="loading"  :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">项目管理</div>
         <el-form  class="zj-search-form"   ref="form"  :model="form" :label-width="labelWidth">         
           <el-form-item label="项目名称">
                  <el-input v-model="fileNmae"  placeholder="请输入项目名称"></el-input>
           </el-form-item>  
           <el-form-item label="文件分类">
             <el-select v-model="FileCategory" placeholder="请选择">
                <el-option key label="全部" value=""></el-option>
                <el-option
                    v-for="item in FileCategoryList"
                    :key="item.ParameterKey"
                    :label="item.ParameterName"
                    :value="item.ParameterKey"
                  ></el-option>
              </el-select> 
             </el-form-item>
              <el-form-item label="文件类型">
                <el-select v-model="FileType" placeholder="请选择">
                  <el-option key label="全部" value=""></el-option>
                  <el-option
                    v-for="item in FileTypeList"
                    :key="item.ParameterKey"
                    :label="item.ParameterName"
                    :value="item.ParameterKey"
                  ></el-option>
                </el-select> 
             </el-form-item>
             <el-form-item label class="right">
                <el-button @click="onSearch">查 询</el-button>
                <el-button @click="onCancel">清 理</el-button>
             </el-form-item>
         </el-form>
         <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
          <div class="zj-layout-main-content bgcolor scrollable">
            <div class="zj-table-container">
              <el-table :data="tableData"  ref="multipleTable" border style="width: 100%" fixed >
                <el-table-column type="index" label="序号" width="80"  align="center"></el-table-column>
                <el-table-column prop="Name" label="项目名称"></el-table-column>
                <el-table-column prop="CategoryDescription" label="资料分类" ></el-table-column>
                <el-table-column prop="TypeDescription" label="文件类型" ></el-table-column>
                <el-table-column prop="CreateTime" label="创建日期" :formatter="formatDate"></el-table-column>
                <el-table-column label="操作" width="120" align="center">
                  <template slot-scope="scope">
                    <el-button @click="EditDetail(scope.$index, scope.row)" type="text" size="small">文件管理</el-button>
                    <el-button @click="deleteClick(scope.$index, scope.row)" type="text" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>
<script>
import MyApis from "../../../apis";
export default {
  name: "MaterialManagement",
  controller: "UI",
  action: "MaterialManagement",
  data() {
      return{
        currentPage: 1,
        pageSize: 20,
        total: 0,
        FileCategoryList:[],
        FileTypeList:[],
        fileNmae:"",
        FileCategory:"",
        FileType:"",
        loading: false,
        loadingText: "加载中...",
        tableData: []
      }
  },
  created:function() {
      this.GetMaterialCategory();
      this.GetMaterialFileType();
  },
  mounted: function() {
      this.search();
  },
  methods: {
    GetMaterialCategory(){
           new MyApis.MaterialConfigurationApi().
           GetAllMaterialCategory()
           .then((r)=>{
                r = r.data.Data;
                this.FileCategoryList=r.PageContents;
           })
           .catch((e) => {
               this.loading = false;
               console.log(e);
               this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
           });
    },
    GetMaterialFileType(){
           new MyApis.MaterialConfigurationApi().
           GetAllMaterialFileType()
           .then((r)=>{
                r = r.data.Data;
                this.FileTypeList=r.PageContents;
           })
           .catch((e) => {
               this.loading = false;
               console.log(e);
               this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
           });
      },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    }, 
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.fileNmae = "";
      this.FileCategory = "";
      this.FileType = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    search(){
      let searchinfo={
        Category:this.FileCategory,
        Type:this.FileType,
        Name:this.fileNmae,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      
      this.loadingText="加载中...";
      this.loading = true;
      new MyApis.MaterialManagementApi().
      GetMaterialDataList(searchinfo)
       .then((r)=>{
         r = r.data.Data;
         this.tableData=r.PageContents;
         this.total = r.BaseSearch.TotalCount;
         this.loading = false;
       })
       .catch((e) => {
         this.loading = false;
         console.log(e);
         this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
       });
    },
    onAdd(){
      this.$router.push({
        path: "/plugin/MaterialManage/UI/MaterialInfo",
        query: {
          type: "add"
        },
      });
    },
    EditDetail(index, row){
      this.$router.push({
        path: "/plugin/MaterialManage/UI/MaterialInfo",
        query: { InfoId: row.ID,MaterialId: row.MaterialId,module:row.Name,type: "edit" },
      });
    },
     deleteClick(index, row){
        this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        })
        .then(()=>{
          this.loading = true;
          this.loadingText = "删除中...";
          new MyApis.MaterialManagementApi()
          .DelMaterialData(row)
          .then((r) => {
            r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.loading = false;
              this.search();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });

        }) 
     },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    },
  }
}
</script>